import { cms } from 'assets/cms';
import {
  HeadlineTwo,
  WrapperCenter,
} from 'components/atoms/SectionWrapper.style';
import React from 'react';
import styled from 'styled-components';

const Img = styled.img`
  height: 40px;
  margin: 15px;
`;
const ImgWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  margin-bottom: 30px;
`;

const Partners = () => (
  <>
    <WrapperCenter>
      <HeadlineTwo>Nasi partnerzy:</HeadlineTwo>
      <ImgWrapper>
        <Img src={cms.partners.eko} />
        <Img src={cms.partners.ekoenergetyka} />
        <Img src={cms.partners.hibox} />
        <Img src={cms.partners.lignajjo} />
        <Img src={cms.partners.prebiel} />
      </ImgWrapper>
    </WrapperCenter>
  </>
);

export default Partners;
